import React from "react";

/** A network the wallet uses. The default yellow dot marks a test network. */
export const NetworkPill: React.FC<{ children: React.ReactNode; dot?: string }> = ({
  children,
  dot = "bg-yellow-400",
}) => (
  <span className="inline-flex items-center gap-1.5 rounded-full bg-sa-surface-hover px-2.5 py-1 text-xs font-medium text-sa-text-muted">
    <span className={`h-1.5 w-1.5 rounded-full ${dot}`} aria-hidden="true" />
    {children}
  </span>
);
